/** @jsx onetext.jsx.element */

import type { OneText } from '../../../global';

// eslint-disable-next-line no-restricted-syntax
import {
    EverGreenHeartBeigeBow, EverGreenHeartBeigeHeart, EverGreenHeartPinkBow, EverGreenHeartPinkHeart1,
    EverGreenHeartRedBow, EverGreenHeartRedHeart2
} from '../images';

declare let onetext : OneText;

const { clsx } = onetext.jsx;

export const BrandBackgroundEvergreenHeart = () : JSX.Element => (
    <div className={ 'absolute inset-0' }>
        <img
            src={ EverGreenHeartBeigeBow }
            className={
                clsx(
                    'absolute',
                    'hidden lg:block',
                    'top-[5%] left-[5%] w-[140px] -rotate-45'
                )
            } />
        <img
            src={ EverGreenHeartBeigeBow }
            className={
                clsx(
                    'absolute',
                    'hidden lg:block',
                    'top-[15%] right-[3%] w-[100px] rotate-45'
                )
            } />
        <img
            src={ EverGreenHeartBeigeBow }
            className={
                clsx(
                    'absolute',
                    'hidden lg:block',
                    'top-[70%] right-[50%] w-[100px]'
                )
            } />
        <img
            src={ EverGreenHeartPinkBow }
            className={
                clsx(
                    'absolute',
                    'hidden lg:block',
                    'bottom-[8%] right-[5%] w-[100px] -rotate-45'
                )
            } />
        <img
            src={ EverGreenHeartPinkBow }
            className={
                clsx(
                    'absolute',
                    'hidden lg:block',
                    'bottom-[5%] left-[10%] w-[150px]'
                )
            } />

        <img
            src={ EverGreenHeartPinkBow }
            className={
                clsx(
                    'absolute',
                    'hidden lg:block',
                    'top-[3%] right-[15%] w-[170px] -rotate-[30deg]'
                )
            } />

        <img
            src={ EverGreenHeartRedBow }
            className={
                clsx(
                    'absolute',
                    'hidden lg:block',
                    'bottom-[3%] right-[40%] w-[165px] rotate-12'
                )
            } />

        <img
            src={ EverGreenHeartRedBow }
            className={
                clsx(
                    'absolute',
                    'hidden lg:block',
                    'left-[3%] bottom-[40%] w-[145px] -rotate-45'
                )
            } />

        <img
            src={ EverGreenHeartRedBow }
            className={
                clsx(
                    'absolute',
                    'hidden lg:block',
                    'top-[5%] right-[50%] w-[120px] rotate-12'
                )
            } />

        <img
            src={ EverGreenHeartRedBow }
            className={
                clsx(
                    'absolute',
                    'hidden lg:block',
                    'right-[5%] top-[50%] w-[90px] rotate-12'
                )
            } />

        <img
            src={ EverGreenHeartPinkHeart1 }
            className={
                clsx(
                    'absolute',
                    'hidden lg:block',
                    'right-[5%] top-[35%] w-[45px] rotate-12'
                )
            } />

        <img
            src={ EverGreenHeartPinkHeart1 }
            className={
                clsx(
                    'absolute',
                    'hidden lg:block',
                    'right-[50%] top-[50%] w-[60px] rotate-12'
                )
            } />

        <img
            src={ EverGreenHeartPinkHeart1 }
            className={
                clsx(
                    'absolute',
                    'hidden lg:block',
                    'left-[20%] top-[5%] w-[30px] rotate-12'
                )
            } />
        <img
            src={ EverGreenHeartPinkHeart1 }
            className={
                clsx(
                    'absolute',
                    'hidden lg:block',
                    'left-[5%] top-[35%] w-[30px]'
                )
            } />
        <img
            src={ EverGreenHeartBeigeHeart }
            className={
                clsx(
                    'absolute',
                    'hidden lg:block',
                    'bottom-[25%] left-[5%] w-[45px]'
                )
            } />

        <img
            src={ EverGreenHeartBeigeHeart }
            className={
                clsx(
                    'absolute',
                    'hidden lg:block',
                    'right-[20%] bottom-[8%] w-[65px]'
                )
            } />

        <img
            src={ EverGreenHeartBeigeHeart }
            className={
                clsx(
                    'absolute',
                    'hidden lg:block',
                    'right-[55%] top-[20%] w-[40px]'
                )
            } />
        <img
            src={ EverGreenHeartBeigeHeart }
            className={
                clsx(
                    'absolute',
                    'hidden lg:block',
                    'right-[5%] bottom-[30%] w-[45px]'
                )
            } />
        <img
            src={ EverGreenHeartBeigeHeart }
            className={
                clsx(
                    'absolute',
                    'hidden lg:block',
                    'right-[15%] top-[35%] w-[45px]'
                )
            } />

        <img
            src={ EverGreenHeartBeigeHeart }
            className={
                clsx(
                    'absolute',
                    'hidden lg:block',
                    'left-[16%] bottom-[35%] w-[65px]'
                )
            } />
        <img
            src={ EverGreenHeartBeigeHeart }
            className={
                clsx(
                    'absolute',
                    'hidden lg:block',
                    'top-[5%] right-[35%] w-[65px] rotate-12'
                )
            } />
        <img
            src={ EverGreenHeartRedHeart2 }
            className={
                clsx(
                    'absolute',
                    'hidden lg:block',
                    'right-[8%] top-[3%] w-[40px]'
                )
            } />
        <img
            src={ EverGreenHeartRedHeart2 }
            className={
                clsx(
                    'absolute',
                    'hidden lg:block',
                    'left-[20%] top-[20%] w-[60px] -rotate-12'
                )
            } />
        <img
            src={ EverGreenHeartRedHeart2 }
            className={
                clsx(
                    'absolute',
                    'hidden lg:block',
                    'bottom-[10%] left-[30%] w-[50px]'
                )
            } />

        <img
            src={ EverGreenHeartRedHeart2 }
            className={
                clsx(
                    'absolute',
                    'hidden lg:block',
                    'right-[15%] bottom-[30%] w-[50px]'
                )
            } />

        { /* Mobile background */ }

        <img
            src={ EverGreenHeartPinkBow }
            className={
                clsx(
                    'absolute',
                    'block lg:hidden',
                    'bottom-[8%] right-[35%] w-[130px]'
                )
            } />

    </div>
);
